module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_1_null@3x.91903b30.png";